import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
const BCXehopdongtable = React.memo(function BCXehopdongtable(props) {
  const classes = useStyles();
  const { data } = props;
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th}>TT</th>
          <th className={classes.tablebc_th}>Chỉ tiêu</th>
          <th className={classes.tablebc_th}>Đơn vị</th>
          <th className={classes.tablebc_th}>Số lượng</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        <tr>
          <td className={classes.tablebc_td}>1</td>
          <td className={classes.tablebc_td}>Tổng số đơn vị tham gia</td>
          <td className={classes.tablebc_td}>đơn vị</td>
          <td className={classes.tablebc_td}>{data.p4_tongdonvi}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Doanh nghiệp</td>
          <td className={classes.tablebc_td}>-nt-</td>
          <td className={classes.tablebc_td}>{data.p4_doanhnghiep}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Hợp tác xã</td>
          <td className={classes.tablebc_td}>-nt-</td>
          <td className={classes.tablebc_td}>{data.p4_htx}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Hộ kinh doanh</td>
          <td className={classes.tablebc_td}>-nt-</td>
          <td className={classes.tablebc_td}>{data.p4_hokinhdoanh}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>2</td>
          <td className={classes.tablebc_td}>Tổng số phương tiện</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{data.p4_tongphuongtien}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Sức chứa dưới 09 chỗ</td>
          <td className={classes.tablebc_td}>-nt-</td>
          <td className={classes.tablebc_td}>{data.p4_sophuongtien_duoi9c}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Sức chứa từ 09 - 25 chỗ</td>
          <td className={classes.tablebc_td}>-nt-</td>
          <td className={classes.tablebc_td}>{data.p4_sophuongtien_9_25c}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Sức chứa từ trên 25 chỗ</td>
          <td className={classes.tablebc_td}>-nt-</td>
          <td className={classes.tablebc_td}>{data.p4_sophuongtien_tren25c}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>3</td>
          <td className={classes.tablebc_td}>Số chuyến xe thực hiện</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>{data.p4_sochuyenxethuchien}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>4</td>
          <td className={classes.tablebc_td}>Sản lượng khách vận chuyển</td>
          <td className={classes.tablebc_td}>lượt khách</td>
          <td className={classes.tablebc_td}>{data.p4_sokhachvanchuyen}</td>
        </tr>
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = renderTableBody();
  return (
    <div>
      <table className={classes.tablebc}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

BCXehopdongtable.propTypes = {
  data: PropTypes.object,
};
export default BCXehopdongtable;
